import React from 'react';
import { Col, Divider, Drawer, List, Row, Tag, Typography } from 'components';
import { SupplierPriceInfo, SupplierPricesDrawerProps } from './types';
import { Link } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';
import styles from './styles.module.scss';
import moment from 'moment/moment';

export const SupplierPricesDrawer: React.FC<SupplierPricesDrawerProps> = ({ visible, onClose, item }) => {
  const renderSupplierName = (supplier: SupplierPriceInfo) => {
    return (
      <Row>
        <Link to={`${ADMIN_ROUTES.suppliers.view}/${supplier.supplierId}/general`} target={'_blank'}>
          {supplier.supplierName}
        </Link>
        {supplier.isMain && (
          <Tag color="success" className={styles.supplierTag}>
            Main
          </Tag>
        )}
        {supplier.isPriceReference && (
          <Tag color="processing" className={styles.supplierTag}>
            Price Reference
          </Tag>
        )}
        {supplier.isBlacklisted && (
          <Tag color="blue" className={styles.supplierTag}>
            Blacklisted
          </Tag>
        )}
        {supplier.isInactive && (
          <Tag color="default" className={styles.supplierTag}>
            Inactive
          </Tag>
        )}
      </Row>
    );
  };

  const renderPrice = (supplier: SupplierPriceInfo) => {
    if (supplier.isInactive) {
      return <Typography.Text className={styles.priceValue}>N/A</Typography.Text>;
    }
    return <Typography.Text className={styles.priceValue}>€{supplier.price || 0}</Typography.Text>;
  };

  return (
    <Drawer title="All Suppliers Prices" open={visible} onClose={onClose} width={450}>
      <List
        dataSource={item.supplierOffers}
        renderItem={(supplier) => {
          let leadTime = '';

          const { leadTimeMin, leadTimeMax } = supplier;
          if (leadTimeMin && leadTimeMax) {
            leadTime = `${leadTimeMin} - ${leadTimeMax}`;
          } else if (leadTimeMin) {
            leadTime = leadTimeMin;
          } else if (leadTimeMax) {
            leadTime = leadTimeMax;
          }

          return (
            <>
              <Row justify="space-between" align="top">
                <Col>{renderSupplierName(supplier)}</Col>
                <Col>{renderPrice(supplier)}</Col>
              </Row>

              <Row gutter={[16, 8]} style={{ marginTop: 8 }}>
                <Col span={24}>
                  <Row justify={'space-between'}>
                    <Col>
                      <Typography.Text type="secondary">Source</Typography.Text>
                    </Col>
                    <Col>{supplier.source || '-'}</Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row justify={'space-between'}>
                    <Col>
                      <Typography.Text type="secondary">Expiry Date:</Typography.Text>
                    </Col>
                    <Col>{supplier.expiryDate ? moment(supplier.expiryDate).format('DD.MM.YYYY') : '-'}</Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row justify={'space-between'}>
                    <Col>
                      <Typography.Text type="secondary">Created Date:</Typography.Text>
                    </Col>
                    <Col>{supplier.createdDate ? moment(supplier.createdDate).format('DD.MM.YYYY') : '-'}</Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row justify={'space-between'}>
                    <Col>
                      <Typography.Text type="secondary">Lead time</Typography.Text>
                    </Col>
                    <Col>{leadTime ? `${leadTime} ${supplier.leadTime}` : '-'}</Col>
                  </Row>
                </Col>
              </Row>
              <Divider style={{ margin: '16px 0' }} />
            </>
          );
        }}
      />
    </Drawer>
  );
};
